import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { fadeUp, staggerContainer, viewportOnce } from "@/lib/motion";
import { SunArcs } from "@/components/SunArcs";

const LOCALITIES = [
  "Costa",
  "Entroterra",
  "Mare",
  "Borghi",
  "In tutto il Salento",
];

const PINS = [
  { x: 116, y: 70 },
  { x: 78, y: 118 },
  { x: 128, y: 216 },
  { x: 100, y: 262 },
];

export const Zona = () => (
  <section id="zona" data-testid="section-zona" className="relative overflow-hidden bg-cream py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 md:grid-cols-2 md:px-12">
      <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <motion.p variants={fadeUp} className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-gold">
          Zona di operatività
        </motion.p>
        <motion.h2 variants={fadeUp} className="font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
          Operiamo in tutto il Salento.
        </motion.h2>
        <motion.p variants={fadeUp} className="mt-7 text-base leading-relaxed text-text-muted sm:text-lg">
          Costa ed entroterra, mare e borghi: seguiamo strutture in ogni angolo del Salento. Ovunque si
          trovi il tuo immobile, portiamo lo stesso metodo basato sui dati — con la conoscenza del
          territorio che fa la differenza sul prezzo.
        </motion.p>
        <motion.div variants={fadeUp} className="mt-9 flex flex-wrap gap-3">
          {LOCALITIES.map((loc, i) => (
            <span
              key={i}
              data-testid={`locality-${i}`}
              className="inline-flex items-center gap-1.5 rounded-full border border-navy/15 bg-white/70 px-4 py-2 text-sm font-medium text-navy backdrop-blur-sm transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              <MapPin className="h-3.5 w-3.5 text-gold" />
              {loc}
            </span>
          ))}
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={viewportOnce}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative flex justify-center"
      >
        <SunArcs className="pointer-events-none absolute -top-10 w-[420px] max-w-full" rings={5} spin opacity={0.18} color="#1F3A5F" />
        <svg viewBox="0 0 220 320" className="relative w-64 max-w-full md:w-80" aria-label="Mappa stilizzata del Salento" role="img">
          <defs>
            <linearGradient id="salentoFill" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#1F3A5F" />
              <stop offset="1" stopColor="#2c4f7c" />
            </linearGradient>
          </defs>
          <path
            d="M150 20 C170 45 168 80 158 110 C150 135 150 160 140 190 C132 214 120 240 104 262 C92 278 78 292 66 288 C54 284 58 264 64 246 C72 222 66 205 58 188 C48 168 40 150 48 128 C56 106 80 96 96 78 C110 62 120 38 138 24 C142 20 146 18 150 20 Z"
            fill="url(#salentoFill)"
            stroke="#C9A227"
            strokeWidth="2"
          />
          {PINS.map((p, i) => (
            <g key={i} data-testid={`map-pin-${i}`}>
              <circle cx={p.x} cy={p.y} r="4.5" fill="#C9A227" />
              <circle cx={p.x} cy={p.y} r="9" fill="none" stroke="#C9A227" strokeWidth="1" opacity="0.5" />
            </g>
          ))}
          <text
            x="105"
            y="165"
            textAnchor="middle"
            fill="#FAF7F2"
            fontSize="15"
            letterSpacing="3"
            fontFamily="Outfit, sans-serif"
            fontWeight="600"
            opacity="0.9"
          >
            SALENTO
          </text>
        </svg>
      </motion.div>
    </div>
  </section>
);
